import React from 'react';
import Helmet from 'react-helmet';

import { useLocation } from 'react-router-dom';
import { useFetchMetaTag } from 'store/hooks/use-fetch-meta-tag';
const CUSTOM_CANONICAL = {
  '/viagra': '/sildenafil',
  '/revatio': '/sildenafil',
  '/lipitor': '/atorvastatin',
};

const getCanonicalForPath = (path) => `https://www.blinkhealth.com${path}`;

const getDefaultMeta = (path) => {
  return {
    title: 'Blink Health Online Pharmacy & Discount Prescriptions',
    description:
      'Get up to 80% discount on your prescriptions when you shop with Blink Pharmacy. Same pills. Lower prices.',
    canonical: CUSTOM_CANONICAL[path] || getCanonicalForPath(path),
    noindex: false,
  };
};

type Props = {
  title?: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
  meta?: Array<{
    name: string;
    content: string;
  }>;
  link?: Array<{
    rel: string;
    href: string;
  }>;
};

const Meta = ({
  title: customTitle = '',
  description: customDescription = '',
  canonical: customCanonical = '',
  noindex: customNoIndex = false,
  meta: customMeta = [],
  link: customLink = [],
}: Props) => {
  const { pathname } = useLocation();
  const defaultMeta = getDefaultMeta(pathname);
  const cmsMeta = useFetchMetaTag(pathname);
  const title = cmsMeta.title || customTitle || defaultMeta.title;
  const description = cmsMeta.description || customDescription || defaultMeta.description;
  const canonical = cmsMeta.canonical || customCanonical || defaultMeta.canonical;
  const noindex = cmsMeta.noindex || customNoIndex || defaultMeta.noindex;
  const meta = [
    ...customMeta,
    {
      name: 'og:title',
      content: title,
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'description',
      content: description,
    },
    {
      name: 'og:description',
      content: description,
    },
    {
      name: 'twitter:description',
      content: description,
    },
  ];
  const link = [...customLink];

  if (canonical) {
    link.push({
      rel: 'canonical',
      href: canonical,
    });
    meta.push({
      name: 'og:url',
      content: canonical,
    });
  }

  if (noindex) {
    meta.push({
      name: 'robots',
      content: 'noindex',
    });
  }

  return (
    <Helmet>
      <title>{title}</title>
      {meta
        .filter((m) => m.content)
        .map((m, index) => (
          <meta key={`meta-${index}`} name={m.name} content={m.content} />
        ))}
      {link
        .filter((l) => l.href)
        .map((l, index) => (
          <link key={`link-${index}`} rel={l.rel} href={l.href} />
        ))}
    </Helmet>
  );
};

export default Meta;
